export enum TrackLearningType {
    LEARNING = "LEARNING",
    ASSESSMENT = "ASSESSMENT",
    LEARNING_AND_ASSESSMENT = "LEARNING_AND_ASSESSMENT"
}
